import { createDynamicQueryResource } from '@subtile/project-shared';
import type { Accessor } from 'solid-js';
import document, { type AccountTransactionsVars } from '../queries/accountTransactionsQuery';
import type { AccountTransactions } from '../types';

export default (variables: Accessor<AccountTransactionsVars | null>) =>
  createDynamicQueryResource<AccountTransactions, AccountTransactionsVars>(document, variables);
